import React from "react";

import { usePlayContext } from "../../pages/Play/play-context";
import { FrameStencils } from "../../types";
import { getActionStencils, getMarkerStencils, getMovements } from "../../utils";
import { MarkerDefs } from "../marker-defs";
import { useTextMarkerEditor } from "../text-marker-editor/hooks";
import { TextMarkerEditor } from "../text-marker-editor/text-marker-editor";
import { Action } from "./action";
import { Marker } from "./marker";

export interface FrameStencilDrawingProps {
  orientation: number;
  frameStencils: FrameStencils;
  isEditable?: boolean;
}

export const FrameStencilDrawing = (props: FrameStencilDrawingProps) => {
  const { orientation, frameStencils, isEditable = false } = props;

  const { frameStencilsApi } = usePlayContext();

  const textMarkerEditor = useTextMarkerEditor({
    frameStencils,
    updateFrameStencils: frameStencilsApi.updateFrameStencils,
  });

  const movementActionIds = getMovements(frameStencils).map((m) => m.id);

  return (
    <>
      <MarkerDefs />

      {/* Markers */}
      {getMarkerStencils(frameStencils).map((marker) => (
        <Marker
          marker={marker}
          orientation={orientation}
          frameStencils={frameStencils}
          isEditable={isEditable}
          handleEditText={textMarkerEditor.openTextEditor}
          key={marker.id}
        />
      ))}

      {/* Actions */}
      {getActionStencils(frameStencils).map((action) => (
        <Action action={action} key={action.id} animateable={movementActionIds.includes(action.id)} />
      ))}

      <TextMarkerEditor {...textMarkerEditor} />
    </>
  );
};
